import React from 'react';
import { SSRTeamData } from '$/utils/ssr';

export interface CompanySSRContextValue {
  isSSR: boolean;
  team?: SSRTeamData;
}

export const CompanySSRContext = React.createContext({} as CompanySSRContextValue);

export const useCompanySSRContext = (): CompanySSRContextValue => {
  return React.useContext(CompanySSRContext);
};
